export const HOME = "/";
export const FARM = "/farm";
export const PROVENANCE = "/provenance";
export const DUNGEON = "/dungeon";
export const WALLET = "/wallet";
export const BROWSE = "/browse";
export const WAIFU = "/waifu";
export const UWUCREW = "/uwucrew";
